/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import { setToast } from '../../../store/ToastManagement';
import {
  Container,
  Grid,
  Segment
} from 'semantic-ui-react';
import { useCurrentUser } from '../../../_services/hooks/user';
import { servicesAPI } from '../../../_services';

import '../customerDetail_styles.css';

const Config = require('../../../conf');

export const ConvertHUBToAON = () => {
  const history = useHistory();

  const { currentUser } = useCurrentUser();

  const [customer, setCustomer] = useState(null);
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  useEffect(() => {
    if (!currentUser) return;

    servicesAPI.CustomerServices('getByUserId', currentUser.id).then(customer => setCustomer(customer));
  }, [currentUser]);

  if (!customer) {
    return (
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 880 }}>
            <Segment>
              <div className="aon-modal">
                <div className="aon-frame">
                  <div className="aon-text-box">
                    <span className="aon-text-box-span-bold">
                      Loading your details, please wait...
                      <br />
                    </span>
                  </div>
                </div>
              </div>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>      
    );
  };

  return (
    <div style={{
      background: '#00205B',
      minHeight: '100vh',
      width: '100%',
      margin: 0,
      padding: 0
    }}>
      {(customer.customer_conversion_status === 'EOI_NOTIFIED' || customer.customer_conversion_status === 'EOI_INPROGRESS') && (
        <div style={{ 
          background: '#00205B', 
          minHeight: '100vh',
          padding: '20px 20px 200px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '32px'
        }}>
          {/* Main Content - No Logo, using global header */}
          <div style={{ 
            width: '100%',
            maxWidth: '663px',
            padding: '0 135px',
            display: 'flex',
            flexDirection: 'column',
            gap: '30px',
            marginTop: '10px'
          }}>
            {/* Message Box */}
            <div style={{
              background: '#FFFFFF',
              borderRadius: '4px',
              padding: '10px',
              color: '#00205B',
              fontSize: '12px',
              lineHeight: 'normal',
              fontFamily: 'Inter, sans-serif'
            }}>
              <p style={{ margin: 0, marginBottom: '12px' }}>
                We've noticed you've started exploring Trojan Home, <br />
                our home-connected EV charger.
              </p>
              <p style={{ margin: 0 }}>
                You can keep using your Hub account as normal while you complete your Trojan Home setup. 
              </p>
            </div>

            {/* CTA Section */}
            <div style={{ 
              display: 'flex',
              flexDirection: 'column',
              gap: '10px'
            }}>
              {/* Title */}
              <div style={{
                color: '#FFFFFF',
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 'bold',
                marginBottom: '5px'
              }}>
                What would you like to do?
              </div>

              {/* Button 1 */}
              <div 
                onClick={() => {
                  document.location.href = '/customer/dashboard';
                }}
                style={{
                  background: 'linear-gradient(90deg, #00EDD7 0%, #84D012 100%)',
                  borderRadius: '6px',
                  padding: '0 24px',
                  height: '61px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <span style={{
                  color: '#00205B',
                  fontSize: '12px',
                  fontFamily: 'TheFuture-Bold, Arial, sans-serif',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  lineHeight: '61px'
                }}>
                  Continue setting up Trojan Home
                </span>
                <span style={{ 
                  fontSize: '32px', 
                  color: '#00205B',
                  fontWeight: 'bold',
                  lineHeight: '1',
                  transform: 'scaleY(-1)'
                }}>›</span>
              </div>

              {/* Button 2 */}
              <div 
                onClick={async () => {
                  if (dontShowAgain) {
                    try {
                      console.log('Updating conversion status for customer:', customer.id);
                      const result = await servicesAPI.CustomerServices('setConversionStatus', customer.id, { new_conversion_status: 'EOI_USER_REJECTED' });
                      console.log('Conversion status update result:', result);
                    } catch (error) {
                      console.error('Failed to update conversion status. Error details:', error);
                      displayMessage('Error', `Failed to save your preference: ${error}`, false);
                      return;
                    }
                  }
                  history.push('/customer/charging');
                }}
                style={{
                  background: 'linear-gradient(90deg, #00EDD7 0%, #84D012 100%)',
                  borderRadius: '6px',
                  padding: '0 24px',
                  height: '61px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <span style={{
                  color: '#00205B',
                  fontSize: '12px',
                  fontFamily: 'TheFuture-Bold, Arial, sans-serif',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  lineHeight: '61px'
                }}>
                  Take me to my HUB account
                </span>
                <span style={{ 
                  fontSize: '32px', 
                  color: '#00205B',
                  fontWeight: 'bold',
                  lineHeight: '1',
                  transform: 'scaleY(-1)'
                }}>›</span>
              </div>

              {/* Checkbox */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: '0px'
              }}>
                <div style={{
                  width: '22px',
                  height: '22px',
                  border: '1px solid #616161',
                  borderRadius: '6px',
                  background: '#FFFFFF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
                onClick={() => setDontShowAgain(!dontShowAgain)}
                >
                  {dontShowAgain && (
                    <div style={{
                      width: '14px',
                      height: '14px',
                      background: '#00205B',
                      borderRadius: '3px'
                    }} />
                  )}
                </div>
                <span 
                  style={{
                    color: '#FFFFFF',
                    fontSize: '10px',
                    fontFamily: 'Inter, sans-serif',
                    lineHeight: '1.5',
                    cursor: 'pointer'
                  }}
                  onClick={() => setDontShowAgain(!dontShowAgain)}
                >
                  I no longer wish to register for Home - don't show me this again
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      {customer.customer_conversion_status === 'EOI_SUBMITTED' && (
        <Segment>
          <div className="aon-modal">
            <div className="aon-header">
              <span className="aon-header-span-blue">Expression of Interest: Submitted</span>{' '}
              <span className="aon-header-span-green"></span>
            </div>
            <br />
            <div className="aon-frame">
              <div className="aon-text-box">
                <span className="aon-text-box-span-bold">
                  Your expression of interest has been submitted. We'll be in touch soon.
                  <br />
                </span>
              </div>
            </div>
          </div>
        </Segment>
      )}
      {customer.customer_conversion_status === 'EOI_APPROVED' && (
        <Segment>
          <div className="aon-modal">
            <div className="aon-header">
              <span className="aon-header-span-blue">Expression of Interest: Approved</span>{' '}
              <span className="aon-header-span-green"></span>
            </div>
            <br />
            <div className="aon-frame">
              <div className="aon-text-box">
                <span className="aon-text-box-span-bold">
                  Great news! Your expression of interest has been approved. You can now continue with your Trojan Home setup.
                  <br />
                </span>
              </div>
            </div>
          </div>
        </Segment>
      )}
      {customer.customer_conversion_status === 'EOI_TROJAN_REJECTED' && (
        <Segment>
          <div className="aon-modal">
            <div className="aon-header">
              <span className="aon-header-span-blue">Expression of Interest: Not Available</span>{' '}
              <span className="aon-header-span-green"></span>
            </div>
            <br />
            <div className="aon-frame">
              <div className="aon-text-box">
                <span className="aon-text-box-span-bold">
                  Unfortunately, Trojan Home is not available for your location at this time. Please continue using your HUB account.
                  <br />
                </span>
              </div>
            </div>
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <div
                onClick={() => {
                  history.push('/customer/charging');
                }}
                style={{
                  background: 'linear-gradient(90deg, #00EDD7 0%, #84D012 100%)',
                  borderRadius: '6px',
                  padding: '0 24px',
                  height: '61px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'opacity 0.2s',
                  minWidth: '300px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
                onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
              >
                <span style={{
                  color: '#00205B',
                  fontSize: '12px',
                  fontFamily: 'TheFuture-Bold, Arial, sans-serif',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  lineHeight: '61px'
                }}>
                  Take me to my HUB account
                </span>
              </div>
            </div>
          </div>
        </Segment>
      )}
    </div>
  );
};
